module.exports = __webpack_public_path__ + "img/battery_0purple.e9a765f1.png";